import { RealTimeDataStore } from "@app/services/store/real-time-data-store";
import { WebStompEntitySubscriber } from "@app/services/webstomp/web-stomp-entity-subscriber.service";
import { Injectable, inject } from "@angular/core";
import { VisitTypeResourceRestService } from "@app/services/hal/visit-type-resource-rest.service";
import { VisitTypeResource } from "@app/models/rest/visit-type-resource";
import { HateoasResourceService } from "@lagoshny/ngx-hateoas-client";

@Injectable({ providedIn: "root" })
export class VisitTypeResourceStore extends RealTimeDataStore<VisitTypeResource> {
  constructor() {
    const visitTypeResourceRestService = inject(VisitTypeResourceRestService);
    const webStompSubscriber = inject(WebStompEntitySubscriber);
    const hateoasResourceService = inject(HateoasResourceService);

    super(
      visitTypeResourceRestService,
      webStompSubscriber,
      hateoasResourceService
    );
    super.subscribeToMessaging("VisitTypeResource");
  }
}
